

const getRedirectUri = () => {
  const env = window.location.host;
  
  if (env.includes("localhost")) {
    return import.meta.env.VITE_AZURE_REDIRECT_URI_LOCAL;    
  } else if (env.includes("dev-")) {
    return import.meta.env.VITE_AZURE_REDIRECT_URI_NONPROD;
  } else {
    return import.meta.env.VITE_AZURE_REDIRECT_URI;
  }
};

const getMsalConfig = () => {
  const env = window.location.host;
  
  // Get environment variables (must start with VITE_ in Create React App)
  const clientId = env.includes("localhost") || env.includes("dev-") 
    ? import.meta.env.VITE_AZURE_CLIENT_ID_NONPROD
    : import.meta.env.VITE_AZURE_CLIENT_ID;
    
  const tenantId = env.includes("localhost") || env.includes("dev-")
    ? import.meta.env.VITE_AZURE_TENANT_ID_NONPROD
    : import.meta.env.VITE_AZURE_TENANT_ID;

  if (!clientId || !tenantId) {
    throw new Error("Missing Azure AD configuration. Please check your environment variables.");
  }

  return {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: getRedirectUri(),
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    }
  };
}

export const msalConfig = getMsalConfig();